module.exports = __webpack_public_path__ + "static/media/speaker2_mobile.97aa28e5.png";